import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import isArray from 'lodash-es/isArray'
import isNull from 'lodash-es/isNull'
import isString from 'lodash-es/isString'
import isUndefined from 'lodash-es/isUndefined'
import wpapix from '@/lib/wpapix'
import { Logger } from '@/lib/logger'

const wpApiSettings = window.wpApiSettings
const wp = window.wp
const FETCH_COUNT = 100
const DEFAULT_LAYOUT = 'suave'

Vue.use( Vuex )

export default new Vuex.Store({
  state: Object.assign({}, window.achernar_local_vars, {
    post: {},
    window: {
      width: 0,
      height: 0
    },
    loading: {},
    mainLoaders: {
      page: true,
      logout: true,
      login: true,
      register: true,
    },
    loadingMessage: {
      login: 'Signing In',
      logout: 'Siging out',
      register: 'Signing up',
    },
    model: {},
    cookies: {},
    layout: DEFAULT_LAYOUT,
    overlay: false,
    currentModal: null,
    currentSidebar: null,
    mediaStack: [],
    playing: null,
    hero: null,
    scroll: 0,
    isDeveloper: process.env.NODE_ENV === 'development',
    playerMute: false,
    previewMute: true,
    playerVolume: 1,
    playingType: null,
    uploads: {},
    files: {
      sending: [],
      preparing: [],
      modified: [],
      error: [],
      sent: [],
    },
    menu: null,
    currentPage: null,
    currentEpisode: null,
    navigation: [],
    settings: null
  }),
  mutations: {
    setLayout( state, layout ) {
      state.layout = layout
    },
    setPostData( state, post ) {
      state.post = post
    },
    startLoading( state, loader ) {
      Vue.set( state.loading, loader, true )
    },
    stopLoading( state, loader ) {
      Vue.set( state.loading, loader, false )
    },
    showOverlay( state ) {
      state.overlay = true
    },
    hideOverlay( state ) {
      state.overlay = false
    },
    openSidebar( state, sidebar ) {
      state.currentSidebar = sidebar
    },
    closeSidebar( state ) {
      state.currentSidebar = null
    },
    openModal( state, modal ) {
      state.currentModal = modal
    },
    closeModal( state, result ) {
      if ( state.currentModal ) {
        const { resolve } = state.currentModal
        state.currentModal = null
        resolve( result )
      }
    },
    setUserData( state, userData ) {
      const current = state.user
      if ( userData === null ) {
        state.user = null
      } else {
        state.user = Object.assign( {}, current, userData )
      }
    },
    pushPlaying( state, media ) {
      state.mediaStack.unshift( media )
      state.playing = media
    },
    popPlaying( state ) {
      state.mediaStack.shift()
      state.playing = state.mediaa[0]
    },
    replacePlaying( state, media ) {
      if (state.mediaStack.length ) {
        state.mediaStack[0] = media
      } else {
        state.mediaStack.push( media )
      }
    },
    setPlayingPreview( state ) {
      state.playingType = 'preview'
    },
    setPlayingFull( state ) {
      state.playingType = 'full'
    },
    setPlayingPlay( state ) {
    },
    setPlayingPause( state ) {
    },
    setPlayingMute( state ) {
      if ( state.playingType === 'full' ) {
        state.playerMute = true
      } else {
        state.previewMute = true
      }
    },
    setPlayingUnmute( state ) {
      if ( state.playingType === 'full' ) {
        state.playerMute = false
      } else {
        state.previewMute = false
      }
    },
    setPlayingVolume( state, volume ) {
      state.playerVolume = volume
    },
    setPlayingSeek( state, time ) {
    },
    setPlayingSpeed( state, speed ) {
    },
    setHero( state, hero ) {
      state.hero = hero
    },
    updateHeroData( state, heroData ) {
      if ( state.hero ) {
        state.hero.data = Object.assign({}, state.hero.data, heroData )
      }
    },
    scrolledDown( state, scroll ) {
      state.scroll = scroll
    },
    scrolledUp( state, scroll ) {
      state.scroll = scroll
    },
    scrollAtTop( state ) {
      state.scroll = 0
    },
    createUpload( state, name ) {
      Vue.set( state.uploads, name, {
        defaults: {
          collections: [],
          tags: [],
          // restrictions: {
          //   public: false,
          //   private: true,
          //   auth: false,
          //   members: false,
          //   payperview: false,
          //   premium: false,
          //   plus: false,
          //   product: null,
          //   users: [],
          //   preview: null,
          //   show: false,
          // }
        },
        files: []
      })
    },
    setUploadDefaults( state, { name, defaults }) {
      const upload = state.uploads[ name ]
      upload.defaults = defaults
    },
    addFile( state, { name, key, file, model, meta = {}, status, error }) {
      state.uploads[ name ].files = [ ...state.uploads[ name ].files, {
        key,
        file,
        model,
        meta,
        status,
        uploaded: null,
        request: null,
        error,
      }]
    },
    removeFile( state, { name, key }) {
      state.uploads[ name ].files =
         state.uploads[ name ].files.filter( f => f.key !== key )
    },
    setFileStatus( state, { name, key, status, model, error }) {
      const upload = state.uploads[ name ]
      const file = upload.files.find( f => f.key === key )
      if ( file ) {
        file.status = status
        file.error = error
        if ( model ) {
          file.model = model
        }
      } // TODO: else error
    },
    setFileUpload( state, { name, key, uploaded }) {
      const upload = state.uploads[ name ]
      const file = upload.files.find( f => f.key === key )
      if ( file ) {
        file.uploaded = uploaded
      } // TODO: else error
    },
    setFileRequest( state, { name, key, request }) {
      const upload = state.uploads[ name ]
      const file = upload.files.find( f => f.key === key )
      if ( file ) {
        file.request = request
      } // TODO: else error
    },
    setFileMeta( state, { name, key, meta }) {
      const upload = state.uploads[ name ]
      const file = upload.files.find( f => f.key === key )
      file.meta = meta
      if ( file.status === 'sent' ) {
        file.status = 'updated'
      }
    },
    setCookies( state, cookies ) {
      state.cookies = { ...state.cookies, ...( cookies || {} )}
    },
    updateModelCache( state, { model, items }) {
      let collection = state.model[ model ]
      if ( !collection) {
        Vue.set( state.model, model, {} )
        collection = state.model[ model ]
      }
      for ( const item of items ) {
        if ( collection[ item.id ]) {
          collection[ item.id ] = item
        } else {
          Vue.set( collection, item.id, item )
        }
      }
    },
    updateSettings( state, settings ) {
      state.settings = settings
    },
    pushMenu( state, menu ) {
      state.navigation = [ menu, ...state.navigation ]
    },
    popMenu( state ) {
      state.navigation.shift()
    },
    setMenu( state, menu ) {
      state.menu = menu
    },
    setMenuPath( state, path ) {
      if ( !state.menu ) return
      path = path.split('/').filter( x => x )
      let [ page, episode ] = path
      if ( !page ) {
        state.currentPage = null
        state.currentEpisode = null
      } else {
        page = state.menu.find( x => x.slug === page )
        state.currentPage = page
        if ( !page ) {
          state.currentEpisode = null
        } else {
          state.currentPage = page
          if ( !page.children ) {
            state.currentEpisode = null
          } else {
            let found = null
            for ( const reel of page.children ) {
              if ( reel.children ) {
                found = reel.children.find( x => x.slug === episode )
              }
              if ( found ) break
            }
            state.currentEpisode = found
          }
        }
      }
    }
  },
  actions: {
    setLayout({ commit }, layout ) {
      commit( 'setLayout', layout )
    },
    setPostData({ commit, dispatch }, post ) {
      commit( 'setPostData', post )
      setTimeout(() => {
      dispatch( 'stopLoading', 'page' )
        dispatch( 'stopLoading', 'admin-page' )
      }, 250 )
    },
    startLoading({ commit }, loader ) {
      commit( 'startLoading', loader )
    },
    stopLoading({ commit }, loader ) {
      commit( 'stopLoading', loader )
    },
    openSidebar({ commit }, { name, data = {} }) {
      commit( 'showOverlay' )
      commit( 'openSidebar', { name, data })
    },
    closeSidebar({ state, commit }) {
      commit( 'closeSidebar' )
      if ( !state.currentModal ) {
        commit( 'hideOverlay' )
      }
    },
    openModal({ commit }, { name, data = {} }) {
      let resolve, reject
      const promise = new Promise(( r, j ) => {
        resolve = r
        reject = j
      })
      commit( 'showOverlay' )
      commit( 'openModal', { name, data, resolve, reject })
      return promise
    },
    closeModal({ state, commit }, result ) {
      commit( 'closeModal', result )
      if ( !state.currentSidebar ) {
        commit( 'hideOverlay' )
      }
    },
    showOverlay({ commit }) {
      commit( 'showOverlay' )
    },
    hideOverlay({ commit }) {
      commit( 'hideOverlay' )
    },
    async request({ state, commit }, { method = 'GET', action, data }) {
      const result = await axios({
        method,
        url: `${state.ajax.url}/${action}`,
        data,
        withCredentials: true,
        headers: {
          cookie: state.cookies
        }
      }).catch ( error => {
        Logger.error( 'request error', 'store/request()', error )()
        return { error, data: error.response && error.response.data }
      })
      Logger.debug( 'reqquest response', 'store/request()', result )()
      if ( result && result.headers ) {
        commit( 'setCookies', result.headers[ 'set-cookie' ])
      }
      return result
    },
    reload({ dispatch }, url ) {
      if ( window.history ) {
        dispatch( 'startLoading', 'page' )
        if ( url )  {
          window.history.go( url )
        } else {
          window.history.go()
        }
      }
    },
    async userLogin({ dispatch, commit }, request ) {
      dispatch( 'startLoading', 'login' )
      let result = null
      try {
        const { status, data, error } = await dispatch( 'request', {
          method: 'post',
          action: 'login',
          data: request
        })
        if ( error ) {
          Logger.debug( 'got login error', 'store/userLogin()',
                        { status, data, error })()
          result = { error, data }
          // TODO: get message and display
        } else {
          Logger.debug( 'got login response', 'store/userLogin()', { status, data })()
          result = { data, message: 'You\'re logged in' }
          commit( 'setUserData', data.user )
          // TODO: get message and display
          dispatch( 'reload' )
        }
      } catch ( error ) {
        Logger.error( 'server error', 'store/userLogin()', error )()
        result = {
          result: 'system-error',
          error: "We're sorry! There was some problem. Please try again later"
        }
      } finally {
        dispatch( 'stopLoading', 'login' )
      }
      return result
    },
    async userGetOTP({ dispatch }, request ) {
      dispatch( 'startLoading', 'get-otp' )
      let result = null
      try {
        const { status, data, error } = await dispatch( 'request', {
          method: 'post',
          action: 'get-otp',
          data: request
        })
        if ( error ) {
          Logger.debug( 'got login error', 'store/userLogin()',
                        { status, data, error })()
          result = { error, data }
          // TODO: get message and display
        } else {
          Logger.debug(
            'got login link response',
            'store/userGetOTP()',
            { status, data }
          )()
          result = { data, message: 'Login token sent' }
          // TODO: get message and display
        }
      } catch ( error ) {
        Logger.error( 'server error', 'store/userLogin()', error )()
        result = {
          result: 'system-error',
          error: "We're sorry! There was some problem. Please try again later"
        }
      } finally {
        dispatch( 'stopLoading', 'get-otp' )
      }
      return result
    },
    async userRegister({ dispatch, commit }, request ) {
      dispatch( 'startLoading', 'register' )
      let result = null
      try {
        const { status, data, error } = await dispatch( 'request', {
          method: 'post',
          action: 'register',
          data: request
        })
        if ( error ) {
          Logger.debug( 'got register error', 'store/userRegister()',
                        { status, data, error })()
          result = { error, data }
          // TODO: get message and display
        } else {
          result = { data, message: 'You\'re logged in' }
          commit( 'setUserData', data.user )
          // TODO: get message and display
          dispatch( 'reload' )
        }
      } catch ( error ) {
        Logger.error( 'server error', 'store/userRegister()', error )()
        result = {
          result: 'system-error',
          error: "We're sorry! There was some problem. Please try again later"
        }
      } finally {
        dispatch( 'stopLoading', 'register' )
      }
      return result
    },
    async userLogout({ dispatch } ) {
      dispatch( 'startLoading', 'logout' )
      let result = null
      try {
        const { status, data, error } = await dispatch( 'request', {
          method: 'post',
          action: 'logout',
        })
        if ( error ) {
          Logger.debug( 'got logout error', 'store/userLogout()',
                        { status, data, error })()
          result = { error, data }
          // TODO: get message and display
        } else {
          Logger.debug( 'got logout response', 'store/userLogout()',
                        { status, data })()
          result = { data, message: 'You\'re logged out!' }
          // TODO: get message and display
          dispatch( 'reload', '/' )
        }
      } catch ( error ) {
        Logger.error( 'server error', 'store/userLogout()', error )()
        result = {
          error: 'system-error',
          message: "We're sorry! There was some problem. Please try again later"
        }
        dispatch( 'stopLoading', 'logout' )
      }
      return result
    },
    pushPlaying({ commit }, media ) {
      commit( 'pushPlaying', media )
    },
    popPlaying({ commit }) {
      commit( 'popPlaying' )
    },
    replacePlaying({ commit }, media ) {
      commit( 'replacePlaying', media )
    },
    setPlayingPlay({ commit }) {
      commit( 'setPlayingPlay' )
    },
    setPlayingPause({ commit }) {
      commit( 'setPlayingPause' )
    },
    setPlayingMute({ commit }) {
      commit( 'setPlayingMute' )
    },
    setPlayingUnmute({ commit }) {
      commit( 'setPlayingUnmute' )
    },
    setPlayingVolume({ commit }, volume ) {
      commit( 'setPlayingVolume', volume )
    },
    setPlayingSeek({ commit }, time ) {
      commit( 'setPlayingSeek', time )
    },
    setPlayingSpeed({ commit }, speed ) {
      commit( 'setPlayingSpeed', speed )
    },
    setHero({ commit }, { name, data = {} }) {
      commit( 'setHero', { name, data })
    },
    updateHeroData({ commit }, data ) {
      commit( 'updateHeroData', data )
    },
    // update to back-end
    async createUpload({ state, dispatch, commit }, name ) {
      if ( !state.uploads[ name ]) {
        commit( 'createUpload', name )
      }
      return state.uploads[ name ]
    },
    setUploadDefaults({ commit }, { name, defaults }) {
      commit( 'setUploadDefaults', { name, defaults })
    },
    async submitUpload({ state, dispatch, commit },  name ) {
      const upload = state.uploads[ name ]
      for ( const f of upload.files ) {
        if ( f.status === 'preparing' ) {
          const { file, key, meta, status } = f
          let result
          try {
            result = await dispatch(
              'sendFile',
              { name, file, key, meta, status }
            )
          } catch ( error ) {
            commit( 'setFileStatus', { name, key, status: 'error', error })
          }
        }
      }
    },
    async cancelUpload({ state, dispatch, commit }, name ) {
      const upload = state.uploads[ name ]
      // TODO: cancel any uploads in progress
      state.uploads[ name ] = null
    },
    async addUploadFile({ commit }, { name, file, key }) {
    },
    async sendFile({ state, commit}, { name, file, key, meta, status }) {
      const createFields = {
        date: true,
        date_gmt: true,
        slug: true,
        status: true,           // publish, future, draft, pending, private
        title: true,
        author: true,
        comment_status: true,   // open, closed
        ping_status: true,      // open, closed
        meta: true,
        template: true,
        alt_text: true,
        caption: true,
        description: true,
        post: true,
      }
      commit( 'setFileStatus', { name, key, status: 'sending' })
      // const debug = []
      const upload = state.uploads[ name ]
      const extraData = {}
      const { defaults } = upload
      // let restrictions
      const data = new FormData()
      data.append( 'file', file.file )
      // debug.push({ file: file.file })
      let title
      for ( const item of meta ) {
        let { value } = item
        if ( item.name === 'title' ) {
          title = value
          continue
        // } else if ( item.name === 'restrictions' ) {
        //   restrictions = value || defaults.restrictions
        //   continue
        }
        if ( isNull( value ) && defaults[ item.name ]) {
          value = defaults[ item.name ]
        }
        Logger.debug( 'set meta', 'store/sendFile()', item.name, value  )()
        if ( isArray( value )) {
          for ( const v of value ) {
            const n = v.taxonomy || item.name
            if ( !extraData[n] ) {
              extraData[n] = []
            }
            extraData[n].push( v.id || v )
            // debug.push({[n]: v.id || v })
          }
          // data.append( n, JSON.stringify( value.map( v )))
        } else if ( `${ value }`.length ) {
          if ( item.name in createFields ) {
            data.append( item.name, value )
          } else {
            const n = value.taxonomy || item.name
            // extraData[n] = JSON.stringify( value.id || value )
            extraData[n] = value.id || value
            // debug.push({[ value.taxonomy || item.name]: value.id || value })
          }
        }
      }
      // for ( const k in extraData ) {
      //   // data.append( k, JSON.stringify( extraData[k] ))
      //   data.append( k, extraData[k] )
      // }
      data.append( 'title', title || file.name )
      // debug.push({ title: file.name })
      // TODO: startLoading( 'sendFile_${uploadId}' )
      let result
      const newTag = state.settings && state.settings.ach_new_content_tag
      if ( newTag ) {
        if ( extraData.attachment_tag ) {
          if ( extraData.attachment_tag.indexOf( newTag ) < 0 ) {
            extraData.attachment_tag.push( newTag )
          }
        } else {
          extraData.attachment_tag = [ newTag ]
        }
      }
      try {
        Logger.debug(
          'prepared file upload',
          'store/sendFile()',
          Array.from( data.entries() )
        )()
        const media = new wp.api.models.Media()
        const request = media.save( extraData, {
          data,
          contentType: false,
          xhr() {
            const xhr = window.jQuery.ajaxSettings.xhr()
            commit( 'setFileUpload', { name, key, uploads: 0.01 })
            xhr.upload.onprogress = e => {
              const uploaded = e.lengthComputable ? e.loaded / e.total : null
              Logger.debug(
                'hodgesARG',
                'request.progress()',
                { e, upload })()
              commit( 'setFileUpload', { name, key, uploaded })
            }
            Logger.debug( 'xhr()', 'store/sendFile()', xhr )()
            return xhr
          }
        }).catch( error => {
          throw error
        })
        commit( 'setFileRequest', { name, key, request })
        Logger.debug( 'media create request', 'store/sendFile()', request )()
        result = await request
        Logger.debug( 'media create result', 'store/sendFile()', result )()
        result = await media.save( extraData )
        Logger.debug( 'media update result', 'store/sendFile()', result )()
        commit( 'setFileStatus', { name, key, status: 'sent', model: result })
      } catch ( error ) {
        commit( 'setFileStatus', { name, key, status: 'error', error })
      }
      // TODO: stopLoading( 'sendFile_${uploadId}' )
      return result
    },
    setFileStatus({ state, commit }, { name, key, file, meta, status, error }) {
      const f = state.uploads[ name ].files.find( x => x.key === key )
      if ( !f ) {
        commit( 'addFile', { name, key, file, meta, status, error })
      } else {
        commit( 'setFileStatus', { name, key, status, error })
      }
    },
    setFileMeta({ commit }, { name, key, meta }) {
      commit( 'setFileMeta', { name, key, meta })
    },
    removeFile({ commit }, { name, key }) {
      commit( 'removeFile', { name, key })
    },
    abortFileUpload({ state, commit }, { name, key }) {
      const upload = state.uploads[ name ]
      const file = upload.files.filter( f => f.key === key )
      if ( file.request ) {
        file.request.abort()
      }
        commit( 'setFileStatus', { name, key, status: 'pending' })
        commit( 'setFileUpload', { name, key, uploads: 0.01 })
    },
    async getModelCollection({ state, commit }, { model, data = {} }) {
      const collection = new wp.api.collections[ model ]()
      model = collection.model().name
      let items = await collection.fetch({
        data: { per_page: FETCH_COUNT, ...data }
      })
      commit( 'updateModelCache', { model, items })
      while ( collection.hasMore() ) {
        items = await collection.more()
        commit( 'updateModelCache', { model, items })
      }
      return state.model[ model ]
    },
    async getModelObject({ state, commit }, { model, ...data }) {
      const Model = new wp.api.models[ model ]( data )
      const item = await Model.fetch()
      commit( 'updateModelCache', { model, items: [ item ]})
      return item
    },
    async getSettings({ dispatch, commit } ) {
      const settings = await dispatch( 'getModelObject', { model: 'Settings' })
      commit( 'updateSettings', settings )
      return settings
    },
    async getModelsPage({ state }, { model, name, ...data }) {
      const collection = new wp.api.collections[ model ]()
      model = collection.model().name
      const request = collection.fetch({
        data: {
          per_page: FETCH_COUNT,
          _embed: '',
          ...data
        }
      })
      // commit( 'updateModelCache', { model, items })
      // while ( collection.hasMore() ) {
      //   items = await collection.more()
      //   commit( 'updateModelCache', { model, items })
      // }
      Logger.debug( 'request', 'store/getModelsPage()', request )()
      const items = await request
      const total = parseInt( request.getResponseHeader( 'x-wp-total' ))
      const pages = parseInt( request.getResponseHeader( 'x-wp-totalpages' ))
      Logger.debug(
        'item.getCategories',
        'store/getModelsPage()',
        items && items.length && items[0].getCategories
      )()
      return { items, total, pages }
    },
    async updateModelObject({ state, commit }, { model, sync, id, ...data }) {
      const Model = new wp.api.models[ model ]({ id })
      if ( sync ) {
        // await Model.fetch()
        Model.set( data )
      }
      const result = await sync ? Model.sync( 'update', Model ) : Model.save( data )
      Logger.debug( 'update', 'store/updateModelObject()', result )()
      return result
    },
    async updateSettings({ dispatch, commit }, data ) {
      const result = await dispatch( 'updateModelObject', {
        model: 'Settings',
        ...data
      })
      commit( 'updateSettings', result )
      return result
    },
    async deleteObject({ dispatch, commit }, { model, object, confirmed }) {
      const { title, slug, id } = object
      if ( !confirmed ) {
        return dispatch( 'openModal', {
          name: 'm-confirm',
          data: {
            title: 'Really Delete?',
            message: `Are you sure you want to delete ${ model.label }:
 "${ title.rendered || ( isString( title ) ? title : slug ) }"? This cannot be undone.`,
            confirmLabel: 'Delete',
            onConfirm() {
              return dispatch( 'deleteObject', { model, object, confirmed: true })
            }
          }
        })
      }
      const Model = new wp.api.models[ model.model ]({ id })
      Model.requireForceForDelete = true
      const result = await Model.destroy()
      Logger.debug( 'delete', 'store/deleteModelObject()', result )()
      return result
    },
    async deleteObjects({ dispatch, commit }, { model, objects, confirmed }) {
      const titles = objects.map(
        o => `"${ o.title.rendered || ( isString( o.title ) ? o.title : o.slug ) }"`
      ).join(', ')
      if ( !confirmed ) {
        return dispatch( 'openModal', {
          name: 'm-confirm',
          data: {
            title: 'Really Delete?',
            message: `Are you sure you want to delete ${ model.label }: ${ titles }?
This cannot be undone.`,
            confirmLabel: 'Delete',
            onConfirm() {
              return dispatch( 'deleteObjects', { model, objects, confirmed: true })
            }
          }
        })
      }
      const result = await Promise.all( objects.map( object => {
        const Model = new wp.api.models[ model.model ]({ id: object.id })
        Model.requireForceForDelete = true
        return Model.destroy()
      }))
      Logger.debug( 'delete', 'store/deleteModelObject()', result )()
      return result
    },
    async markObjectProcessed({ state, dispatch, commit }, { model, object }) {
      const newTag = state.settings.ach_new_content_tag
      if ( !newTag ) return     // TODO: error
      const Model = new wp.api.models[ model.model ]({ id: object.id })
      const result = await Model.save({
        attachment_tag: ( object.attachment_tag || [] ).filter( x => x !== newTag )
      })
      Logger.debug( 'delete', 'store/deleteModelObject()', result )()
      return result
    },
    async markObjectsProcessed({ state, dispatch, commit }, { model, objects, confirmed }) {
      const titles = objects.map(
        o => `"${ o.title.rendered || ( isString( o.title ) ? o.title : o.slug ) }"`
      ).join(', ')
      if ( !confirmed ) {
        return dispatch( 'openModal', {
          name: 'm-confirm',
          data: {
            title: 'Really Mark All Processed?',
            message: `Are you sure you want to mark ${ model.label }: ${ titles } as processed? If any content has not been attached to a program, you will have to search for it on the general content page.`,
            confirmLabel: 'Mark Processed',
            onConfirm() {
              return dispatch( 'markObjectsProcessed', { model, objects, confirmed: true })
            }
          }
        })
      }
      const newTag = state.settings.ach_new_content_tag
      if ( !newTag ) return     // TODO: error
      const result = await Promise.all( objects.map( object => {
        const Model = new wp.api.models[ model.model ]({ id: object.id })
        const result = Model.save({
          attachment_tag: ( object.attachment_tag || [] ).filter( x => x !== newTag )
        })
      }))
      Logger.debug( 'delete', 'store/markObjectsProcessed()', result )()
      return result
    },
    async MarkAllProcessed({ dispatch, commit }, model = 'Media' ) {
    },
    pushMenu({ commit }, menu) {
      commit( 'pushMenu', menu )
    },
    popMenu({ commit }) {
      commit( 'popMenu' )
    },
    async getMenu({ commit }, path ) {
      if ( path && path.startsWith( '/admin' )) return
      await wpapix
      const Model = new wp.api.models.Menu({ path })
      const menu = await Model.fetch()
      commit( 'setMenu', menu )
      commit( 'setMenuPath', path )
      return menu
    },
    setMenuPath({ commit }, path ) {
      commit( 'setMenuPath', path )
    }
  },
  getters: {
    isLoading: state => {
      const loading = {}
      let found = false
      for ( const loader of Object.keys( state.loading )) {
        if ( state.loading[ loader ]) {
          loading[ loader ] = true
          found = true
        }
      }
      return found ? loading : false
    },
    isMainLoading: state => {
      return Object.keys( state.loading ).find( k => {
        if ( !state.loading[k] ) return false
        return state.mainLoaders[k]
      })
    },
    loggedIn: state => state.user && state.user.id,
    layout: state => state.layout || DEFAULT_LAYOUT,
    can: state => {
      if ( !state.user ) return {}
      const out = {}
      for ( const r of state.user.roles ) {
        Object.assign( out, state.roles[r].capabilities )
      }
      return out
    }
  },
  modules: {
  }
})
